<template>
  <custom-header :is-vacancy="vacancy" />
  <slot></slot>
  <custom-footer />
</template>

<script>
import CustomHeader from "@/components/page/Header.vue";
import CustomFooter from "@/components/page/Footer.vue";

export default {
  name: "custom-page-template",
  components: {
    CustomFooter,
    CustomHeader,
  },
  props: {
    vacancy: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
